import * as yup from 'yup'

export const extractValidationErrors = (errors: yup.ValidationError) => {
	return errors.inner.reduce((acc, curr) => {
		if (curr.path) {
			acc[curr.path] = curr.message
		}
		return acc
	}, {} as Record<string, string>)
}
